"use strict";
/** state: Deprecated **/
/** family: Onboarding **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Backdrop_1 = require("../Backdrop");
var Button_1 = require("../Button");
var OnboardPosition;
(function (OnboardPosition) {
    OnboardPosition["Top"] = "top";
    OnboardPosition["Bottom"] = "bottom";
})(OnboardPosition = exports.OnboardPosition || (exports.OnboardPosition = {}));
var classNamePrefix = 'i-onboard';
/**
 * Onboard groups many components together to produce simple onboarding patterns through 'tours'.
 *
 * Tours are used to introduce new features, or highlight existing unused functionality.
 */
var Onboard = /** @class */ (function (_super) {
    __extends(Onboard, _super);
    function Onboard(props) {
        var _this = _super.call(this, props) || this;
        _this.handleEndTour = function () {
            _this.setState({ currentStep: 0 }, function () {
                if (_this.props.onFinish) {
                    _this.props.onFinish(_this.state.targetElement);
                    _this.setState({ targetElement: null });
                }
            });
        };
        _this.handleNext = function () {
            var currentStep = _this.getStep();
            var currentTarget = document.querySelector(currentStep.selector);
            _this.setState({ targetElement: null });
            if (_this.props.onBeforeNext) {
                var returnValue = _this.props.onBeforeNext(currentTarget, _this.state.currentStep);
                // Do not proceed to the next step if onBeforeNext returns `false`.
                if (typeof returnValue === 'boolean' && !returnValue) {
                    return;
                }
            }
            if (currentStep.onAfter) {
                currentStep.onAfter(currentTarget, _this.state.currentStep);
            }
            _this.setState({ currentStep: _this.state.currentStep + 1 }, function () {
                var nextStep = _this.getStep();
                var nextTarget = document.querySelector(nextStep.selector);
                if (nextStep.onBefore) {
                    nextStep.onBefore(nextTarget, _this.state.currentStep);
                }
                _this.props.onAfterNext &&
                    _this.props.onAfterNext(nextTarget, _this.state.currentStep);
            });
        };
        _this.getStep = function () { return _this.props.steps[_this.state.currentStep]; };
        _this.getVisibleTarget = function () {
            var target = document.querySelector(_this.getStep().selector);
            if (target) {
                var rect = target.getBoundingClientRect();
                var html = document.documentElement;
                if (rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || html.clientHeight) &&
                    rect.right <= (window.innerWidth || html.clientWidth)) {
                    return target;
                }
            }
            return null;
        };
        _this.handleFocus = function () {
            var onboardStepElement = document.querySelector("." + classNamePrefix + "__message");
            var currentElement = document.activeElement;
            if (onboardStepElement.contains(currentElement)) {
                currentElement.focus();
            }
            else {
                onboardStepElement.focus();
            }
        };
        _this.setTarget = function () {
            var step = _this.getStep();
            if (!_this.state.targetElement) {
                // Try to find the target.
                var targetElement = _this.getVisibleTarget();
                if (targetElement) {
                    _this.setState({ targetElement: targetElement });
                }
                else {
                    if (step.skipIfTargetMissing) {
                        if (_this.state.currentStep >= _this.props.steps.length - 1) {
                            _this.handleEndTour();
                        }
                        else {
                            _this.handleNext();
                        }
                        return;
                    }
                    console.warn("Can't find the element specified by the selector \"" + step.selector + "\".");
                    // Wait and try again, and again, and again...
                    var targetStep_1 = _this.state.currentStep;
                    var interval_1 = setInterval(function () {
                        var visibleTarget = _this.getVisibleTarget();
                        if (visibleTarget) {
                            _this.setState({ targetElement: visibleTarget });
                            clearInterval(interval_1);
                        }
                        if (targetStep_1 !== _this.state.currentStep) {
                            clearInterval(interval_1);
                        }
                    }, 500);
                }
            }
        };
        _this.state = {
            currentStep: props.step || 0,
            isMounted: false,
            targetElement: null,
        };
        return _this;
    }
    Onboard.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            _this.setState({ isMounted: true }, function () {
                var step0 = _this.props.steps[0];
                if (step0.onBefore) {
                    step0.onBefore(document.querySelector(step0.selector), 0);
                }
                _this.focusNextActionButton();
                if (_this.props.shown) {
                    _this.setTarget();
                }
            });
        }, this.props.delay);
    };
    Onboard.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.step != null &&
            nextProps.step !== this.state.currentStep) {
            this.setState({ targetElement: null, currentStep: nextProps.step });
        }
    };
    Onboard.prototype.componentDidUpdate = function () {
        this.focusNextActionButton();
        if (this.props.shown) {
            this.addFocusListener();
            this.setTarget();
        }
        else {
            this.focusEventListener &&
                this.focusEventListener.remove();
        }
    };
    Onboard.prototype.componentWillUnmount = function () {
        this.focusEventListener && this.focusEventListener.remove();
    };
    Onboard.prototype.render = function () {
        var _a;
        var shouldRender = this.props.shown && this.state.isMounted;
        var classes = classNames(classNamePrefix + "__mount-node", (_a = {}, _a[classNamePrefix + "__mount-node--shown"] = shouldRender, _a), this.props.className);
        return (React.createElement("div", { className: classes }, shouldRender && this.renderOnboardStep(this.state.currentStep)));
    };
    Onboard.prototype.renderOnboardStep = function (currentStep) {
        var isLastStep = currentStep >= this.props.steps.length - 1;
        var data = this.props.steps[currentStep];
        var onboardMessageContent = (React.createElement("div", { className: classNames(classNamePrefix + "__message", classNamePrefix + "__message--" + (data.position ||
                Onboard.Position.Bottom)), role: "alert", tabIndex: -1 },
            React.createElement(Button_1.Button, { label: this.props.endTourActionLabel, mode: Button_1.Button.Mode.Link, onClick: this.handleEndTour, className: classNamePrefix + "__message__end-tour-button" }),
            this.props.steps.length > 1 && (React.createElement("div", { className: classNames(classNamePrefix + "__message__progress", 'padding-sm') }, (this.state.currentStep || 0) + 1 + " / " + this.props.steps.length)),
            React.createElement("main", { role: "main", className: "padding-md" },
                React.createElement("h1", { className: classNames(classNamePrefix + "__message__title", 'margin-top-0', 'margin-bottom-0') }, data.title),
                React.createElement("div", { className: classNames(classNamePrefix + "__message__body", 'padding-bottom-md', 'padding-top-md') }, data.message),
                React.createElement("div", { className: classNamePrefix + "__message__buttons", ref: this.focusNextActionButton }, !isLastStep ? (React.createElement(Button_1.Button, { label: data.nextStepActionLabel
                        ? data.nextStepActionLabel
                        : this.props.nextStepActionLabel, mode: Button_1.Button.Mode.Primary, onClick: this.handleNext, className: classNamePrefix + "__message__buttons__button" })) : (React.createElement(Button_1.Button, { label: data.endStepActionLabel
                        ? data.endStepActionLabel
                        : this.props.endStepActionLabel, mode: Button_1.Button.Mode.Secondary, onClick: this.handleEndTour, className: classNamePrefix + "__message__buttons__button" }))))));
        var classes = classNames(classNamePrefix + "__element-cover", classNamePrefix + "__element--running-border", this.props.targetHighlightClassName);
        return (React.createElement("div", { className: classNamePrefix },
            this.state.targetElement && (React.createElement("div", { style: this.getCoverElementStyle(this.state.targetElement), className: classes })),
            React.createElement(Backdrop_1.Backdrop, { active: true, zIndex: 999999 }),
            onboardMessageContent));
    };
    Onboard.prototype.getCoverElementStyle = function (element) {
        var elementRect = element.getBoundingClientRect();
        return {
            height: elementRect.height + "px",
            left: elementRect.left + "px",
            top: elementRect.top + "px",
            width: elementRect.width + "px",
        };
    };
    Onboard.prototype.focusNextActionButton = function () {
        var nextBtn = document.querySelector("." + classNamePrefix + "__message__buttons__button");
        if (nextBtn) {
            setTimeout(function () {
                nextBtn.focus();
            });
        }
    };
    Onboard.prototype.addFocusListener = function () {
        var _this = this;
        if (!this.focusEventListener) {
            document.body.addEventListener('focus', this.handleFocus, true);
            this.focusEventListener = {
                remove: function () {
                    _this.focusEventListener = null;
                    document.body.removeEventListener('focus', _this.handleFocus, true);
                },
            };
        }
    };
    Onboard.Position = OnboardPosition;
    Onboard.defaultProps = {
        delay: 0,
    };
    return Onboard;
}(React.Component));
exports.Onboard = Onboard;
//# sourceMappingURL=Onboard.js.map